"use client";
import React, { useState, useEffect } from "react";
import Image from "next/image";
import { Section } from "@/components/ui/Section";
import { Typography } from "@/components/ui";
import { SmartFeature } from "@/lib/data/retail-industry";

interface SmartFeaturesSectionProps {
  smartFeatures: SmartFeature[];
  imgBaseUrl: string;
  title?: string;
  description?: string | React.ReactNode;
}

export default function SmartFeaturesSection({
  smartFeatures,
  imgBaseUrl,
  title,
  description,
}: SmartFeaturesSectionProps) {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  return (
    <>
      {/* Why Smart Retailers Choose Pickcel Section */}
      <Section variant="default" background="white" style={{ paddingBottom: "0px" }}>
        <div className="text-center max-w-4xl mx-auto">
          <Typography variant="h2" as="h2" className="mb-4">
            {title}
          </Typography>
          {description && (
            <Typography variant="large" as="p" className="text-text-secondary mb-4">
              {description}
            </Typography>
          )}
        </div>
      </Section>
      <div>
        {smartFeatures.map((feature, index) => (
          <Section
            variant="default"
            className={index % 2 === 1 ? "bg-gray-50" : "bg-white"}
            key={index}
          >
            <div
              className={`grid lg:grid-cols-2 gap-6 items-center ${
                index % 2 === 1 ? "lg:grid-flow-col-dense" : ""
              }`}
            >
              <div className={index % 2 === 1 ? "lg:col-start-2" : ""}>
                <span
                  className="section-label"
                >
                  {feature.subHeading}
                </span>
                <Typography variant="h3" as="h3" className="mb-4">
                  {feature.title}
                </Typography>
                <Typography variant="body" as="p">
                  {isClient && (
                    typeof feature.description === 'string'
                      ? <span dangerouslySetInnerHTML={{ __html: feature.description }} />
                      : feature.description
                  )}
                </Typography>
              </div>
              <div className={index % 2 === 1 ? "lg:col-start-1" : ""}>
                <Image
                  src={imgBaseUrl + feature.imageUrl}
                  alt={feature.imageAlt}
                  title={feature.imageAlt}
                  width={600}
                  height={400}
                  loading="lazy"
                  sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 600px"
                  className="w-full h-auto rounded-lg shadow-lg max-w-lg mx-auto"
                />
              </div>
            </div>
          </Section>
        ))}
      </div>
    </>
  );
}
